<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">编辑</div>
                    <div
                        class="xc-modal-close"
                        @click="layerClose"
                    ></div>
                </div>
                <div class="xc-modal-body">
                    <form
                        class="xc-form"
                        name="edit"
                        data-vv-scope="edit"
                        style="width: 600px"
                    >
                        <div class="xc-form-inline">
                            <xc-form-item
                                label="账号:"
                                required
                            >
                                <input
                                    type="text"
                                    name="userName"
                                    :value="user.userName"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                    v-validate="'required'"
                                    data-vv-as="账号"
                                    placeholder="请输入账号"
                                    :class="{'xc-input-error':errors.first('userName','edit')}"
                                >
                                <input
                                    type="hidden"
                                    name="userId"
                                    :value="user.userId"
                                />
                                <div class="xc-form-item-error-tips">
                                    {{errors.first("userName","edit")}}
                                </div>
                            </xc-form-item>
                            <xc-form-item
                                label="姓名:"
                                required
                            >
                                <input
                                    type="text"
                                    name="realName"
                                    :value="user.realName"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                    v-validate="'required'"
                                    data-vv-as="姓名"
                                    placeholder="请输入姓名"
                                    :class="{'xc-input-error':errors.first('realName','edit')}"
                                >
                                <div class="xc-form-item-error-tips">
                                    {{errors.first("realName","edit")}}
                                </div>
                            </xc-form-item>
                        </div>
                        <div class="xc-form-inline">
                            <xc-form-item
                                label="手机号码:"
                                required
                            >
                                <input
                                    type="tel"
                                    name="mobilePhone"
                                    :value="user.mobilePhone"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                    v-validate="'required|mobile'"
                                    data-vv-as="手机号码"
                                    placeholder="请输入手机号码"
                                    :class="{'xc-input-error':errors.first('mobilePhone','edit')}"
                                >
                                <div class="xc-form-item-error-tips">
                                    {{errors.first("mobilePhone","edit")}}
                                </div>
                            </xc-form-item>
                            <xc-form-item
                                label="是否启用："
                                required
                                :error="errors.first('status','edit')"
                            >
                                <label class="xc-checkbox-wrap">
                                    <input
                                        type="radio"
                                        name="status"
                                        :checked="user.status==1"
                                        class="xc-radio"
                                        value="1"
                                        v-validate="'required'"
                                        data-vv-as="状态"
                                    >
                                    <span class="xc-checkbox-label">启用</span>
                                </label>
                                <label class="xc-checkbox-wrap">
                                    <input
                                        type="radio"
                                        name="status"
                                        :checked="user.status==0"
                                        class="xc-radio"
                                        value="0"
                                        v-validate="'required'"
                                        data-vv-as="状态"
                                    >
                                    <span class="xc-checkbox-label">禁用</span>
                                </label>
                            </xc-form-item>
                        </div>
                        <div class="xc-form-inline">
                            <xc-form-item label="所属部门">
                                <div class="department">
                                    <input
                                        type="hidden"
                                        name="departmentId"
                                        :value="user.departmentId"
                                    />
                                    <input
                                        type="text"
                                        name="departmentName"
                                        :value="user.departmentName"
                                        class="parentName xc-input xc-input-disabled"
                                        disabled
                                        placeholder="请选择上级部门"
                                    />
                                    <span
                                        class="myDepartment"
                                        @click="selectDepartment"
                                    ><i class="fa fa-align-center"></i> </span>
                                </div>
                            </xc-form-item>
                            <xc-form-item label="角色名称:">
                                <select
                                    name="roleIds"
                                    class="xc-select"
                                >
                                    <option value="">请选择</option>
                                    <template v-if="roles && roles.length">
                                        <option
                                            v-for="(item,index) in roles"
                                            :key="index"
                                            :value="item.roleId"
                                            :selected="item.roleId==user.belongRoleIds"
                                        >{{item.roleName}}
                                        </option>
                                    </template>
                                </select>
                            </xc-form-item>
                        </div>
                        <div class="xc-form-inline">
                            <xc-form-item label="密码：">
                                <input
                                    type="password"
                                    :value="123456"
                                    name="password"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                />
                            </xc-form-item>
                        </div>
                        <xc-form-item label="备注:">
                            <input
                                type="text"
                                name="desc"
                                :value="user.desc"
                                class="xc-input"
                                placeholder="请输入备注"
                            >
                        </xc-form-item>
                        <div class="xc-form-inline">
                            <xc-form-item label="创建时间:">
                                <input
                                    type="text"
                                    name="addTime"
                                    :value="user.addTime"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                    placeholder=""
                                >
                            </xc-form-item>
                            <xc-form-item label="最后修改时间:">
                                <input
                                    type="text"
                                    name="updateTime"
                                    :value="user.updateTime"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                >
                            </xc-form-item>
                        </div>
                        <div class="xc-form-inline">
                            <xc-form-item label="操作人:">
                                <input
                                    type="text"
                                    name="operator"
                                    :value="user.operator"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                >
                            </xc-form-item>
                        </div>
                    </form>
                </div>
                <div class="xc-modal-footer xc-flex-center">
                    <div class="xc-btn-group">
                        <div
                            class="xc-btn xc-btn-default"
                            @click="layerClose"
                        >取消</div>
                        <div
                            class="xc-btn xc-btn-primary"
                            @click="submit"
                        >确定</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myLayerImport from '@/libs/myLayer';
import "@/utils/form-format"
import "@/libs/font-awesome"
// vee-validate验证
import "@/libs/vee-validate";
myLayerImport();
import { getList, getTree } from "../api/department";
import role from "@/api/role"
import user from "@/api/user"
export default {
    name: "UserEdit",
    data() {
        return {
            adminPath: this.$config.adminPath,
            roles: [],
            user: {},
            channel: 0,  //0表示从用户列表进入，1表示从账号设置进入
        }
    },
    created() {
        this.channel = this.$route.query.channel;
        this.user = parent.user;
        var _this = this;
        //    请求角色列表
        role.roleList().then(function (success) {
            _this.roles = success.data.list;
        }).catch(function (error) {
            _this.$message.error("出了一点问题");
        })
    },
    methods: {
        layerClose() {
            var index = parent.layer.getFrameIndex(window.name);
            parent.layer.close(index);
        },
        selectDepartment: function () {
            myLayer.open({
                type: 2,
                title: false,
                closeBtn: 0,
                content: this.adminPath + "/system/department/select",
                success: function (layero, index) {
                    //    声明一个全局函数
                    window.init = function (name, id) {
                        document.getElementsByName("departmentName")[0].value = name;
                        document.getElementsByName("departmentId")[0].value = id;
                    }
                }
            })
        },
        submit: function () {
            var _this = this;
            var myForm = document.edit;
            // 验证器命名空间
            const scope = 'edit';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    return this.$formFormat(myForm);
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                }
            }).then(formData => {
                if (formData) {
                    _this.layerClose();
                    parent.window.update(formData)
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.department {
    position: relative;
    .myDepartment {
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 0 5px 5px 0;
        cursor: pointer;
        box-shadow: -1px 0 2px 0 #bbb;
        width: 32px;
        line-height: 32px;
        text-align: center;
    }
}
</style>
